import { Component, OnInit, Inject } from '@angular/core';
import { Justification } from '../../../Models/justification';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Ship } from '../../../Models/ship';
import { ApiService } from '../../../core/services/api.service';
import { ShipHistoryEnum } from 'src/app/enums/ship-history-enum';

@Component({
    selector: 'dialog-delete-ship',
    templateUrl: './dialog-delete-ship.component.html',
    styleUrls: ['./dialog-delete-ship.component.scss']
})

export class DialogDeleteShipComponent implements OnInit {

  
  justifications: Justification[] = [];

  selectedJustification: Justification;
  shipToEliminate: Ship;
  loadId: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogDeleteShipComponent>,
    private apiService: ApiService) {
    this.getJustifications();
  }

  ngOnInit(): void {
    this.shipToEliminate = this.data.shipToEliminate;
    this.loadId = this.data.loadId;
  }

  getJustifications() {
    this.apiService.get('api/load/justifications/all').subscribe((response: any) => {
      if (response.data) {
        this.justifications = response.data;
        if (this.justifications.length > 0)
          this.selectedJustification = this.justifications[0];
      }
    });
  }

  deleteShip() {
    this.apiService.put<boolean>('api/load/inactiveShip', { id: this.loadId, idShip: this.shipToEliminate.id, idJustification: this.selectedJustification.id, movement: ShipHistoryEnum.MOVE_SHIP_CONFIG_LOAD })
      .subscribe((response: boolean) => {
        this.dialogRef.close(this.selectedJustification);
      });
  }
  
}
